import React from 'react'
import SimpleSlider from '../components/SimpleSlider'


const Services = () => {
  return (
    <>
    {/* <!-- Page Header Start --> */}
    <div class="container-fluid page-header mb-5 p-0" style={{backgroundImage: "url(/img/carousel-bg-2.jpg)"}}>
        <div class="container-fluid page-header-inner py-5">
            <div class="container text-center">
                <h1 class="display-3 text-white mb-3 animated slideInDown">Services</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center text-uppercase">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Pages</a></li>
                        <li class="breadcrumb-item text-white active" aria-current="page">Services</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    {/* <!-- Page Header End --> */}


    {/* <!-- Service Start --> */}
    <div class="container-xxl service py-5">
        <div class="container">
            <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="text-primary text-uppercase">// Our Services //</h6>
                <h1 class="mb-5">Explore Our Services</h1>
            </div>
            <div class="row g-4 wow fadeInUp" data-wow-delay="0.3s">
                <div class="col-lg-4">
                    <div class="nav w-100 nav-pills me-4">
                        <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4 active" data-bs-toggle="pill" data-bs-target="#tab-pane-1" type="button">
                            <i class="fa fa-car-side fa-2x me-3"></i>
                            <h4 class="m-0">Exterior Wash</h4>
                        </button>
                        <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-2" type="button">
                            <i class="fa fa-car fa-2x me-3"></i>
                            <h4 class="m-0">Interior Cleaning</h4>
                        </button>
                        <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-3" type="button">
                            <i class="fa fa-cog fa-2x me-3"></i>
                            <h4 class="m-0">Premium Detailing</h4>
                        </button>
                        <button class="nav-link w-100 d-flex align-items-center text-start p-4 mb-0" data-bs-toggle="pill" data-bs-target="#tab-pane-4" type="button">
                            <i class="fa fa-oil-can fa-2x me-3"></i>
                            <h4 class="m-0">Tire & Wheel Care</h4>
                        </button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="tab-content w-100">
                        <div class="tab-pane fade show active" id="tab-pane-1">
                            <div class="row g-4">
                                <div class="col-md-6" style={{minHeight: "350px"}}>
                                    <div class="position-relative h-100">
                                        <img class="position-absolute img-fluid w-100 h-100" src="/img/service-1.jpg"
                                            style={{objectFit: "cover"}} alt=""/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="mb-3">Professional Car Washing Services</h3>
                                    <p class="mb-4">Our comprehensive car washing services include exterior wash, interior vacuuming, tire cleaning, and dashboard polishing. We use premium quality products that are safe for your vehicle's paint and interior surfaces, ensuring a spotless finish every time.</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Exterior Wash & Polish</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Interior Vacuuming</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Tire & Wheel Cleaning</p>
                                    {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tab-pane-2">
                            <div class="row g-4">
                                <div class="col-md-6" style={{minHeight: "350px"}}>
                                    <div class="position-relative h-100">
                                        <img class="position-absolute img-fluid w-100 h-100" src="/img/service-2.jpg"
                                            style={{objectFit: "cover"}} alt=""/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="mb-3">Interior Deep Cleaning Service</h3>
                                    <p class="mb-4">Our interior cleaning service includes thorough vacuuming, dashboard polishing, seat cleaning, and air freshening. We use specialized tools and premium cleaning products to remove dirt, dust, and stains, leaving your car's interior fresh and spotless.</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Complete Vacuuming</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Dashboard & Console Cleaning</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Seat & Upholstery Care</p>
                                    {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tab-pane-3">
                            <div class="row g-4">
                                <div class="col-md-6" style={{minHeight: "350px"}}>
                                    <div class="position-relative h-100">
                                        <img class="position-absolute img-fluid w-100 h-100" src="/img/service-3.jpg"
                                            style={{objectFit: "cover"}} alt=""/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="mb-3">Premium Car Detailing</h3>
                                    <p class="mb-4">Our premium detailing service provides comprehensive exterior and interior care including waxing, polishing, paint protection, and complete interior deep cleaning. Perfect for maintaining your vehicle's value and appearance.</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Paint Protection & Waxing</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Complete Interior Detailing</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Premium Quality Products</p>
                                    {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tab-pane-4">
                            <div class="row g-4">
                                <div class="col-md-6" style={{minHeight: "350px"}}>
                                    <div class="position-relative h-100">
                                        <img class="position-absolute img-fluid w-100 h-100" src="/img/service-4.jpg"
                                            style={{objectFit: "cover"}} alt=""/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="mb-3">Tire & Wheel Care</h3>
                                    <p class="mb-4">Specialized tire and wheel cleaning service that removes brake dust, road grime, and restores the shine to your wheels. We use safe, non-corrosive products to protect your rims and tires while making them look brand new.</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Wheel Deep Cleaning</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Tire Shine & Protection</p>
                                    <p><i class="fa fa-check text-success me-3"></i>Brake Dust Removal</p>
                                    {/* <a href="" class="btn btn-primary py-3 px-5 mt-3">Read More<i class="fa fa-arrow-right ms-3"></i></a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Service End --> */}


    {/* <!-- Booking Start --> */}
    <div class="container-fluid bg-secondary booking my-5 wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
            <div class="row gx-5">
                <div class="col-lg-6 py-5">
                    <div class="py-5">
                        <h1 class="text-white mb-4">Certified and Award Winning Car Repair Service Provider</h1>
                        <p class="text-white mb-0">UrbanWash is a certified and award-winning car washing service provider. We have been recognized for our excellence in customer service, use of premium eco-friendly products, and commitment to delivering outstanding results. Our experienced team ensures your vehicle receives professional care and attention to detail.</p>
                    </div>
                </div>
                {/* <div class="col-lg-6">
                    <div class="bg-primary h-100 d-flex flex-column justify-content-center text-center p-5 wow zoomIn" data-wow-delay="0.6s">
                        <h1 class="text-white mb-4">Book For A Service</h1>
                        <form>
                            <div class="row g-3">
                                <div class="col-12 col-sm-6">
                                    <input type="text" class="form-control border-0" placeholder="Enter your name (e.g., Karan Malhotra)" style={{height: "55px"}}/>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <input type="email" class="form-control border-0" placeholder="Enter your email (e.g., karan.malhotra@gmail.com)" style={{height: "55px"}}/>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <select class="form-select border-0" style={{height: "55px"}}>
                                        <option selected>Select A Service</option>
                                        <option value="1">Car Washing</option>
                                        <option value="2">Car Detailing</option>
                                        <option value="3">Premium Wash</option>
                                    </select>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="date" id="date1" data-target-input="nearest">
                                        <input type="text"
                                            class="form-control border-0 datetimepicker-input"
                                            placeholder="Select service date" data-target="#date1" data-toggle="datetimepicker" style={{height: "55px"}}/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <textarea class="form-control border-0" placeholder="Any special requests or instructions"></textarea>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-secondary w-100 py-3" type="submit">Book Now</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div> */}
            </div>
        </div>
    </div>
    {/* <!-- Booking End --> */}
    <SimpleSlider/>
    </>
  )
}

export default Services
